// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Zk-z","heading":"_k-z","brandPromo":"al-z"};